<template>
  <div class="health-assessment-page">
    <!-- 背景图片 -->
    <img class="page-bg" :src="bgImage" alt="背景" />

    <!-- Logo -->
    <img class="page-logo" :src="logoImage" alt="Logo"/>

    <!-- 返回按钮 -->
    <img class="page-back-btn" @click="handleBack" :src="backButtonImage" alt="返回"/>

    <!-- 内容区域 -->
    <div class="content-box">
      <!-- 标题 -->
      <div class="bodyMass-title">{{ indicatorName }}
        <!-- <div class="bodyMass-div"></div> -->
      </div>
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 数据内容 -->
      <template v-else>
        <!-- 详细数据提示 -->
        <div class="content-data">
          <img :src="dataAnalysisIcon" alt="数据分析" />
          <span>详细数据</span>
        </div>

        <!-- 指标列表 -->
        <div v-if="indicators.length > 0" class="indicators-list">
          <div
            v-for="(item, index) in indicators"
            :key="index"
            class="indicator-item"
            @click="showDetail(item)"
          >
            <div class="indicator-name">{{ item.name }}</div>
            <div class="indicator-score">{{ item.value }}/100</div>
            <div class="indicator-progress">
              <div
                class="progress-bar"
                :style="{
                  width: `${item.value}%`,
                  backgroundColor: getProgressColor(item.value)
                }"
              ></div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-else class="empty-state">
          <div class="empty-text">暂无数据</div>
        </div>
      </template>
    </div>

    <!-- 底部间距 -->
    <div class="bottom-spacer"></div>

    <!-- 详情弹窗 - 按照 uniapp 固定内容 -->
    <div v-if="detailVisible" class="detail-modal" @click="closeDetail">
      <div class="detail-content" @click.stop>
        <div class="detail-title">{{ titleName }}</div>
        <div class="detail-text" v-html="titleMessage"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex'
import {
  getIndicatorType,
  getIndicatorName,
  transformIndicatorData
} from '@/utils/indicatorMapping'
import { getIndicatorByUserId , bizIntroduce } from '@/api/indicator'

export default {
  name: 'HealthAssessment',
  data() {
    return {
      loading: false,
      indicators: [],
      detailVisible: false,
      indicatorType: null,
      indicatorName: '健康评估',
      sex: 0,
      // 图片资源 - HealthAssessment 页面专用（使用 public 路径）
      bgImage: '/images/backgrounds/home-bg.png',
      logoImage: '/images/backgrounds/title6.png',
      backButtonImage: '/images/home/header-back@1x.png',
      dataAnalysisIcon: '/images/health-assessment/data-analysis@1x.png',
      titleName:"",
      titleMessage:""
    }
  },
  async created() {
    // 从路由参数获取 type 和 sex
    const type = parseInt(this.$route.query.type) || 1
    this.sex = parseInt(this.$route.query.sex) || 0

    // 获取指标类型和名称
    this.indicatorType = getIndicatorType(type, this.sex)
    this.indicatorName = getIndicatorName(type)

    if (!this.indicatorType) {
      console.error('Invalid indicator type:', type)
      return
    }

    await this.loadIndicatorData()
  },
  methods: {
    async loadIndicatorData() {
      this.loading = true
      const userId = this.$route.query.userId
      if (!userId) {
        this.loading = false
        return
      }
      try {
        // 调用 API 获取指标数据
        const rawData = await getIndicatorByUserId(this.indicatorType, { userId })

        // 转换数据格式
        this.indicators = transformIndicatorData(this.indicatorType, rawData)

        // 如果没有数据，显示提示
        if (this.indicators.length === 0) {
          console.warn('No indicator data found for type:', this.indicatorType)
        }
      } catch (error) {
        console.error('Failed to load indicator data:', error)

        // 否则使用 console 输出
        
      } finally {
        this.loading = false
      }
    },
    getProgressColor(value) {
      if (value < 60) return '#FF4D4F' // 高风险 - 红色
      if (value < 75) return '#FA8C16' // 中风险 - 橙色
      if (value < 90) return '#90BB55' // 低风险 - 绿色
      return '#90BB55' // 正常 - 绿色
    },
    showDetail(item) {
      console.log(item.name,"??????");
      
      bizIntroduce(item.name).then(res=>{
					this.titleMessage = res
          this.titleName = item.name
					this.isShow = true
				})
      this.detailVisible = true
    },
    closeDetail() {
      this.detailVisible = false
    },
    handleBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.health-assessment-page {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

// 背景图片
.page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

// Logo
.page-logo {
  position: absolute;
  left: 40rpx;
  top: 50rpx;
  width: 315.6rpx;
  height: 100rpx;
  z-index: 2;
}

// 返回按钮
.page-back-btn {
  position: absolute;
  left: 495rpx;
  top: 65rpx;
  width: 220rpx;
  height: 70rpx;
  border-radius: 10rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6rpx;
  box-sizing: border-box;
  border: 1px solid #FFFFFF;
}

// 内容区域
.content-box {
  position: relative;
  left: 4.5vw; // 36.5rpx*2
  top: 208rpx;
  padding-bottom: 135.4rpx;
  width: 677rpx;
  border-radius: 26rpx;
  background: #FFFFFF;
  z-index: 1;

  @include respond-to(mobile) {
    left: auto;
    top: 160rpx;
    width: calc(100% - 40rpx);
    max-width: 800rpx;
    margin: 0 auto;
  }
}

// 标题
.content-title {
  position: relative;
  left: 0;
  top: 0;
  width: 177rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);

  @include respond-to(mobile) {
    width: 200rpx;
    height: 60rpx;
    line-height: 60rpx;
    font-size: 28rpx;
  }
}

// 详细数据提示
.content-data {
  position: relative;
  left: 46.875rpx;
  margin-top: 26rpx;
  height: 31.25rpx;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4rpx;

  img {
    width: 31.25rpx;
    height: 31.25rpx;
  }

  span {
    font-size: 21rpx;
    color: #3D3D3D;
  }

  @include respond-to(mobile) {
    left: 30rpx;
    margin-top: 20rpx;

    img {
      width: 36rpx;
      height: 36rpx;
    }

    span {
      font-size: 24rpx;
    }
  }
}

// 指标列表
.indicators-list {
  position: relative;
  left: 46.875rpx;
  margin-top: 21rpx;
  width: 583rpx;
  display: flex;
  flex-direction: column;
  // gap: 40rpx;
 
  @include respond-to(mobile) {
    left: 30rpx;
    width: calc(100% - 60rpx);
    // gap: 30rpx;
  }
}

// 指标项
.indicator-item {
  width: 583rpx;
  height: 72rpx;
  position: relative;
  cursor: pointer;
  margin-bottom: 40rpx;
  @include respond-to(mobile) {
    width: 100%;
    height: 80rpx;
  }
}

// 指标名称
.indicator-name {
  position: absolute;
  left: 0;
  top: 0;
  height: 38rpx;
  font-weight: 500;
  font-size: 28rpx;
  line-height: 37.44rpx;
  color: #0E6EB8;
  z-index: 0;

  @include respond-to(mobile) {
    font-size: 30rpx;
    height: 44rpx;
    line-height: 44rpx;
  }
}

// 指标分数
.indicator-score {
  position: absolute;
  right: 0;
  top: 0;
  width: 92rpx;
  height: 38rpx;
  font-weight: 500;
  font-size: 28rpx;
  line-height: 37.44rpx;
  text-align: right;
  color: #0E6EB8;
  z-index: 1;

  @include respond-to(mobile) {
    font-size: 30rpx;
    height: 44rpx;
    line-height: 44rpx;
  }
}

// 进度条容器
.indicator-progress {
  position: absolute;
  bottom: 0;
  width: 583rpx;
  height: 24rpx;
  border-radius: 20rpx;
  overflow: hidden;
  background-color: #EEEEEE;

  @include respond-to(mobile) {
    width: 100%;
    height: 28rpx;
  }
}

// 进度条
.progress-bar {
  height: 100%;
  border-radius: 20rpx;
  transition: width 0.3s ease, background-color 0.3s ease;
}

// 底部间距
.bottom-spacer {
  height: 250rpx;
  position: relative;
  margin-top: 200rpx;

  @include respond-to(mobile) {
    height: 120rpx;
    margin-top: 80rpx;
  }
}

// 详情弹窗遮罩
.detail-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.3);
}

// 详情内容
.detail-content {
  width: 625rpx;
  height: 573rpx;
  position: absolute;
  left: 62.5rpx;
  top: 408rpx;
  border-radius: 26rpx;
  background-color: #FFFFFF;

  // @include respond-to(mobile) {
  //   left: 50%;
  //   top: 50%;
  //   transform: translate(-50%, -50%);
  //   width: calc(100% - 80rpx);
  //   max-width: 700rpx;
  //   height: auto;
  //   min-height: 600rpx;
  //   position: fixed;
  // }
}

// 详情标题
.detail-title {
  position: absolute;
  left: 193rpx;
  top: 0;
  width: 240rpx;
  height: 46.875rpx;
  border-radius: 0 0 26rpx 26rpx;
  font-size: 26rpx;
  color: #fff;
  text-align: center;
  line-height: 46.875rpx;
  background: linear-gradient(280deg, #2397F0 22%, #94DE30 100%);

  @include respond-to(mobile) {
    left: 50%;
    transform: translateX(-50%);
    width: 300rpx;
    height: 60rpx;
    line-height: 60rpx;
    font-size: 28rpx;
  }
}

// 详情文本
.detail-text {
  position: absolute;
  left: 39rpx;
  top: 84rpx;
  width: 546.875rpx;
  height: 343.75rpx;
  overflow-y: auto;
  font-size: 21rpx;
  font-weight: normal;
  line-height: 1.5;
  text-align: justify;
  letter-spacing: 1.5rpx;
  color: #3D3D3D;

  // @include respond-to(mobile) {
  //   position: relative;
  //   left: auto;
  //   top: auto;
  //   width: 100%;
  //   max-height: 600rpx;
  //   font-size: 24rpx;
  //   padding: 100rpx 40rpx 40rpx;
  //   margin-top: 60rpx;
  // }

  // &::-webkit-scrollbar {
  //   width: 8rpx;
  // }

  // &::-webkit-scrollbar-track {
  //   background: #f1f1f1;
  //   border-radius: 4rpx;
  // }

  // &::-webkit-scrollbar-thumb {
  //   background: #888;
  //   border-radius: 4rpx;

  //   &:hover {
  //     background: #555;
  //   }
  // }
}

// 加载状态
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120rpx 40rpx;
  min-height: 400rpx;

  .loading-spinner {
    width: 80rpx;
    height: 80rpx;
    border: 8rpx solid rgba(14, 110, 184, 0.2);
    border-top-color: #0E6EB8;
    border-radius: 50%;
    animation: spin 0.9s linear infinite;
    margin-bottom: 32rpx;
  }

  .loading-text {
    font-size: 28rpx;
    color: #666;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// 空状态
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120rpx 40rpx;
  min-height: 400rpx;

  .empty-text {
    font-size: 28rpx;
    color: #999;
  }
}
.bodyMass-title {
  position: relative;
  left: 18.7rpx;
  top: 18.7rpx;    
  // height: 52px;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 6;
}

.bodyMass-div{
  position: absolute;
  left: 0px;
  top: 30.7rpx;
width: 140rpx;
height: 9.34rpx;
z-index: -1;
/* 主色 */
background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
	
}
</style>
